import React from 'react';

import {useResolvedEntryUrl} from 'coreHooks';

import Link from 'brandComponents/Link';

import {IContentfulEntryLinkProps} from './IContentfulEntryLink';

const ContentfulEntryLink = ({data, children}: IContentfulEntryLinkProps) => {
	const entryData = data as Record<string, any> | undefined;
	const resolvedUrl = useResolvedEntryUrl(entryData?.target, entryData?.uri);

	return resolvedUrl
		? <Link to={resolvedUrl}>{children}</Link>
		: <>{children}</>;
};

export default ContentfulEntryLink;
